import axios from 'axios';
import config from 'shared/config';
import setBaseRequest from 'shared/utils/setBaseRequest';
import qs from 'qs';
import { asyncStart, asyncSuccess, asyncError } from 'redux/domain/AsyncStatus/actions';
import { batchActions } from 'redux-batched-actions';
import { addCache } from 'redux/domain/Cache/actions';
import { createNotification } from 'redux/domain/Notifications/creators';
import { setProviderId } from 'redux/domain/Welcome/creators';
import keyPath from './keyPath';
import {
	receiveStatus,
	receiveNextProviderId,
	receiveNextProviderName,
	receiveNextProviderAutoSubmit,
} from './creators';

/**
 * Retrieve application statuses
 * @param {string} asyncId UUID
 * @param {string} customerId
 * @param {string} STORISLocationId
 * @param {string} providerId
 * @returns {Array} applicationStatuses = { providerId, providerName, appStatusCode, appStatusMessage, url, creditLimit }
 * applicationStatuses.providerId: {int}
 * applicationStatuses.providerName: {string}
 * applicationStatuses.appStatusCode: {int}
 * applicationStatuses.appStatusMessage: {string}
 * applicationStatuses.url: {string}
 * applicationStatuses.creditLimit: {int}
 */
const checkAppStatus = (
	asyncId,
	customerId,
	STORISLocationId,
	providerId,
	returnedFromThirdPartySite,
	cfaTraceId,
) => async dispatch => {
	const asyncKeyPath = keyPath(asyncId);
	const cancellationSource = axios.CancelToken.source();
	// begin sumbmission by setting async status and storing the cancellation source
	dispatch(asyncStart(asyncKeyPath, cancellationSource));
	let response;
	try {
		response = await axios.post(
			`${config.ESTORIS_BASE_PATH}/GetAppStatus`,
			qs.stringify({ customerId, STORISLocationId, providerId, returnedFromThirdPartySite, cfaTraceId }),
			setBaseRequest({}, cancellationSource.token),
		);
		dispatch(
			batchActions([
				addCache(['settings'], response.data),
				receiveStatus(response.data.statusResponse.applicationStatuses),
				receiveNextProviderName(response.data.statusResponse.nextProviderName),
				receiveNextProviderId(response.data.statusResponse.nextProviderId),
				receiveNextProviderAutoSubmit(response.data.statusResponse.nextProviderAutoSubmit),
				setProviderId(response.data.statusResponse.nextProviderId),
				asyncSuccess(asyncKeyPath),
			]),
		);
	} catch (error) {
		if (!axios.isCancel(error)) {
			// fetch completed in error
			dispatch(
				batchActions([
					asyncError(asyncKeyPath, error),
					createNotification('Trouble receiving status code for credit application'),
				]),
			);
		}
	}
	return response;
};

export default checkAppStatus;
